var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGif11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 9,
    viewBox: "0 0 18 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.375 8.25V0.75H10.25V8.25H8.375ZM1.5 8.25C1.125 8.25 0.822917 8.11979 0.59375 7.85938C0.364583 7.59896 0.25 7.3125 0.25 7V2C0.25 1.6875 0.364583 1.40104 0.59375 1.14062C0.822917 0.880208 1.125 0.75 1.5 0.75H5.25C5.625 0.75 5.92708 0.880208 6.15625 1.14062C6.38542 1.40104 6.5 1.6875 6.5 2V2.625H2.125V6.375H4.625V4.5H6.5V7C6.5 7.3125 6.38542 7.59896 6.15625 7.85938C5.92708 8.11979 5.625 8.25 5.25 8.25H1.5ZM12.125 8.25V0.75H17.75V2.625H14V3.875H16.5V5.75H14V8.25H12.125Z",
    fill: "#4B83FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGif11);
export default __webpack_public_path__ + "static/media/gif11.38f8a590ce46b2971cca4b0aba7422d4.svg";
export { ForwardRef as ReactComponent };